/**
 * Spec Section 8 — UI Animations & Transitions
 * Durations and easings take precedence over Figma when they differ.
 */

export const easeOut = [0.16, 1, 0.3, 1];
export const easeInOut = [0.45, 0, 0.55, 1];
export const easeIn = [0.55, 0, 1, 0.45];

export const AUTH = {
  loginToSignup: {
    initial: { x: 40, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -40, opacity: 0 },
    transition: { duration: 0.3, ease: easeInOut },
  },
  signupToLogin: {
    initial: { x: -40, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: 40, opacity: 0 },
    transition: { duration: 0.3, ease: easeInOut },
  },
  loginToReset: {
    initial: { y: 24, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 24, opacity: 0 },
    transition: { duration: 0.25, ease: easeOut },
  },
  toOnboarding: {
    initial: { x: 32, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -24, opacity: 0 },
    transition: { duration: 0.3, ease: easeOut },
  },
  toDashboard: {
    initial: { y: 20, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -12, opacity: 0 },
    transition: { duration: 0.35, ease: easeOut },
  },
};

export const ONBOARDING = {
  stepForward: {
    initial: { x: 48, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -48, opacity: 0 },
    transition: { duration: 0.25, ease: easeOut },
  },
  stepBack: {
    initial: { x: -48, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: 48, opacity: 0 },
    transition: { duration: 0.25, ease: easeOut },
  },
  toDashboard: {
    initial: { scale: 0.95, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.98, opacity: 0 },
    transition: { duration: 0.4, ease: easeOut },
  },
};

export const NAV = {
  toEditor: {
    initial: { x: "12%", opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: "-10%", opacity: 0 },
    transition: { duration: 0.3, ease: easeInOut },
  },
  toDashboardFromEditor: {
    initial: { x: "-12%", opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: "10%", opacity: 0 },
    transition: { duration: 0.3, ease: easeInOut },
  },
  toSettings: {
    initial: { y: 40, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 28, opacity: 0 },
    transition: { duration: 0.3, ease: easeOut },
  },
  fromSettings: {
    initial: { y: -24, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 28, opacity: 0 },
    transition: { duration: 0.25, ease: easeOut },
  },
};

export const MODAL = {
  slideUp: {
    initial: { y: "100%", opacity: 0.9 },
    animate: { y: 0, opacity: 1 },
    exit: { y: "100%", opacity: 0.9 },
    transitionEnter: { duration: 0.3, ease: easeOut },
    transitionExit: { duration: 0.25, ease: easeOut },
  },
  scaleFade: {
    initial: { scale: 0.95, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.95, opacity: 0 },
    transition: { duration: 0.2, ease: easeOut },
    transitionExit: { duration: 0.2, ease: easeIn },
  },
  scaleFadeClimax: {
    initial: { scale: 0.95, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.97, opacity: 0 },
    transition: { duration: 0.3, ease: easeOut },
  },
};

export const BANNER = {
  slideDown: {
    initial: { y: -24, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -16, opacity: 0 },
    transition: { duration: 0.3, ease: easeOut },
  },
};

export const pageMotionProps = (variant) => ({
  initial: variant.initial,
  animate: variant.animate,
  exit: variant.exit,
  transition: variant.transition,
});
